export enum EPaymentProcessingSeverityType {
  None = 0,

  Recent = 1,

  Acceptable = 2,

  Delayed = 3,

  Critical = 4,
}
